<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3>Achievements</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="trophy" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div *ngIf="!achievements" class="card-body">Loading...</div>
    <div *ngIf="achievements" class="card-body">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let a of achievements; let index = index">
          <div class="row">
            <div class="col-6">
              <h5>{{ i18nAchieved(a).title ?? ('Localized [' + languages(a) + ']') }} ({{ a.name }})</h5>
            </div>
            <div *ngIf="a.event_start || a.event_end" class="col-6 text-end">
              <h5>{{ a.event_start | date:dateTimeFormat }} - {{ a.event_end | date:dateTimeFormat }}</h5>
            </div>
          </div>
          <div class="row">
            <span class="text-secondary" [innerHTML]="i18nLocked(a).description"></span>
          </div>
          <div class="row" *ngIf="i18nAchieved(a).description != i18nLocked(a).description">
            <span class="text-primary" [innerHTML]="i18nAchieved(a).description"></span>
          </div>
          <div>
            <div class="btn-group float-end">
              <button class="btn btn-light" type="button" [disabled]="loading" (click)="navigate(a.uuid)">
                <fa-icon icon="pencil" size="md"></fa-icon>
                Edit
              </button>
              <button class="btn btn-danger" type="button" [disabled]="loading" (click)="remove(a, index)">
                <fa-icon icon="trash" size="md"></fa-icon>
                Delete
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row my-2">
            <div style="width: auto">
              <button class="btn btn-primary" type="button" (click)="navigate('new')">
                <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                Add Achievement
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
